export default "__VITE_ASSET__NzR3$Jyv__"